// extracted by mini-css-extract-plugin
module.exports = {"legendList":"CodeInsightLegend_legendList__0UFk4","legendItem":"CodeInsightLegend_legendItem__YkfS2","legendMark":"CodeInsightLegend_legendMark__Hf7Qa"};